// extracted by mini-css-extract-plugin
export default {"clear":"reset_clear_dRxhc","clearfix":"reset_clearfix_0poYr"};